<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper" ref="formContainer">
      <!-- Page Content -->
      <div class="content container-fluid">
        <!-- Page Header -->
        <leaves-admin-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          :hasCreatePermission="hasCreatePermission"
          :hasImportPermission="hasImportPermission"
        />
        <!-- /Page Header -->

        <!-- Search Filter -->
        <div class="row filter-row" v-if="isAdmin">
          <div class="col-sm-6 col-md-2">
            <div class="input-block mb-3 form-focus focused">
              <vue-select
                :options="employee_list"
                id="payslipEmployee"
                v-model="form.employee_id"
                placeholder="-"
              />

              <label class="focus-label">Employee Name</label>
            </div>
          </div>
          <div class="col-sm-6 col-md-2">
            <div class="input-block mb-3 form-focus select-focus">
              <div class="input-block mb-3 form-focus focused">
                <vue-select
                  :options="department"
                  id="payslipDepartment"
                  v-model="form.department_id"
                  placeholder="-"
                />

                <label class="focus-label">Department</label>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-2">
            <div class="input-block mb-3 form-focus select-focus">
              <vue-select
                :options="months"
                v-model="form.month"
                id="month-one"
                placeholder="-"
              />
              <label class="focus-label">Select Month</label>
            </div>
          </div>

          <div class="col-sm-6 col-md-2">
            <div class="input-block mb-3 form-focus select-focus">
              <vue-select
                :options="statusOptions"
                id="status"
                placeholder="-"
                v-model="form.status"
              />
              <label class="focus-label">Select Status</label>
            </div>
          </div>

          <div class="col-sm-6 col-md-2">
            <div class="d-grid">
              <a
                href="javascript:;"
                class="btn btn-success submit-btn"
                style="min-width: 180px"
                @click="filterPayslip"
              >
                Search
              </a>
            </div>
          </div>
          <div class="col-sm-6 col-md-2">
            <div class="d-grid">
              <a
                href="javascript:;"
                class="btn btn-danger submit-btn"
                style="min-width: 180px"
                @click="clearFilter"
              >
                Clear
              </a>
            </div>
          </div>
        </div>
        <!-- /Search Filter -->

        <div class="row">
          <div class="col-md-12">
            <div class="showentries mb-3">
              <label
                >Show
                <select v-model="pagination.pageSize" @change="updatePerPage">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div>
            <div class="table-responsive">
              <a-table
                class="stripped table-hover"
                :columns="columns"
                :data-source="data"
                :pagination="pagination"
                @change="handleTableChange"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'employee'">
                    <router-link v-if="record?.employee" :to="'profile/' + record.employee.id">
                      {{ record?.employee?.first_name || "—" }}
                      {{ record?.employee?.last_name || "" }}
                    </router-link>
                    <span v-else>—</span>
                  </template>
                  <template v-if="column.key === 'department'">
                    {{ record.department ? record.department.name : "—" }}
                  </template>
                  <template v-if="column.key === 'period'">
                    <div class="text-left">
                      {{ record.month && months[record.month - 1] ? months[record.month - 1].text + "-" + record.year : "—" }}
                    </div>
                  </template>
                  <template v-if="column.key === 'reason'">
                    <div class="text-left">
                      {{ record.reason }}
                    </div>
                  </template>

                  <!-- STATUS -->
                  <template v-if="column.key === 'status'">
                    <div class="text-left">
                      <div v-if="isEmployee" class="action-label">
                        <a
                          class="btn btn-white btn-sm btn-rounded"
                          href="javascript:void(0);"
                        >
                          <i :class="record.Class"></i>
                          {{ capitalizeFirst(record.status) }}
                        </a>
                      </div>
                      <div v-if="isAdmin && hasEditPermission" class="dropdown action-label">
                        <a
                          class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                          href="javascript:;"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i :class="record.Class"></i>
                          {{ capitalizeFirst(record.status) }}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a
                            class="dropdown-item"
                            href="javascript:;"
                            data-bs-toggle="modal"
                            data-bs-target="#approve_payslip"
                            @click="updateStatus(record.id, 'pending')"
                            ><i class="fa-regular fa-circle-dot text-info"></i>
                            Pending</a
                          >
                          <a
                            class="dropdown-item"
                            href="javascript:;"
                            data-bs-toggle="modal"
                            data-bs-target="#approve_payslip"
                            @click="updateStatus(record.id, 'approved')"
                            ><i
                              class="fa-regular fa-circle-dot text-success"
                            ></i>
                            Approved</a
                          >
                          <a
                            class="dropdown-item"
                            href="javascript:;"
                            data-bs-toggle="modal"
                            data-bs-target="#approve_payslip"
                            @click="updateStatus(record.id, 'rejected')"
                            ><i
                              class="fa-regular fa-circle-dot text-danger"
                            ></i>
                            Rejected</a
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="column.key === 'approvedby'">
                    <div
                      class="text-left"
                      v-if="record.status == 'approved' && record.resolved_by"
                    >
                      {{ record?.resolved_by?.first_name || "—" }}
                      {{ record?.resolved_by?.last_name || "" }}
                    </div>
                    <h4
                      class="table-avatar"
                      v-if="record.status == 'Approved' && record.resolved_by"
                    >
                      <!--
                      <router-link to="profile" class="avatar avatar-xs"
                        ><img
                          :src="require(`@/assets/img/profiles/${record.Image}`)"
                          alt="User Image"
                      /></router-link>-->
                      <!--<a href="javascript:;">{{ record.Approvedby }}</a> -->
                    </h4>
                  </template>
                  <template v-if="column.key === 'remarks'">
                    <div class="text-left">
                      {{ record.remarks }}
                    </div>
                  </template>

                  <!-- ACTION -->
                  <template v-else-if="column.key === 'action'">
                    <div class="text-end">
                      <button
                        v-if="hasEditPermission && record.payslip_path"
                        class="btn btn-primary m-r-5"
                        href="javascript:;"
                        @click="downloadPayslip(record.id)"
                        title="Download"
                      >
                        <i class="fa-solid fa-download"></i>
                      </button>
                      <button
                        v-if="hasEditPermission && isAdmin"
                        class="btn btn-primary m-r-5"
                        href="javascript:;"
                        data-bs-toggle="modal"
                        data-bs-target="#upload_payslip"
                        @click="uploadFile(record.id)"
                        title="Upload"
                      >
                        <i class="fa-solid fa-upload"></i>
                      </button>
                      <a
                        v-if="hasDeletePermission && isAdmin"
                        class="btn btn-danger"
                        href="javascript:;"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_payslip"
                        @click="deletePayslip(record.id)"
                        title="Delete"
                      >
                        <i class="fa-regular fa-trash-can text-white"></i></a
                      >
                    </div>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
    </div>
    <!-- /Page Wrapper -->
    <payslip-request-model
      :update_id="updateId"
      :update_status="status"
      @update-payslip-status="updatePayslipStatus"
      @reload-data="loadCommonData"
    />
  </div>
</template>

<script>
const adminColumns = [
  {
    title: "Employee Name",
    dataIndex: "employee",
    key: "employee",
    sorter: false,
  },
  {
    title: "Deptartment",
    dataIndex: "department",
    key: "department",
    sorter: false,
  },
  {
    title: "Period",
    dataIndex: "period",
    key: "period",
    sorter: false,
  },
  {
    title: "Reason",
    dataIndex: "reason",
    key: "reason",
    sorter: false,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    sorter: false,
  },
  {
    title: "Approved by",
    dataIndex: "approvedby",
    key: "approvedby",
    sorter: false,
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    key: "remarks",
    sorter: false,
  },
  {
    title: "Action",
    sorter: false,
    key: "action",
    class: "text-end",
  },
];

const employeeColumns = [
  {
    title: "Period",
    dataIndex: "period",
    key: "period",
  },
  {
    title: "Reason",
    dataIndex: "reason",
    key: "reason",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Approved by",
    dataIndex: "approvedby",
    key: "approvedby",
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    key: "remarks",
  },
  {
    title: "Action",
    key: "action",
    class: "text-end",
  },
];

import axios from "axios";
import { notification } from "ant-design-vue";
import * as bootstrap from "bootstrap";

export default {
  data() {
    return {
      title: "Payslip",
      path: "Dashboard",
      text: "Payslip",
      text1: "Add Payslip Request",
      columns: [],
      pagination: { total: 0, current: 1, pageSize: 10 },
      data: [],
      months: [
        { id: 1, text: "January" },
        { id: 2, text: "February" },
        { id: 3, text: "March" },
        { id: 4, text: "April" },
        { id: 5, text: "May" },
        { id: 6, text: "June" },
        { id: 7, text: "July" },
        { id: 8, text: "August" },
        { id: 9, text: "September" },
        { id: 10, text: "October" },
        { id: 11, text: "November" },
        { id: 12, text: "December" },
      ],
      statusOptions: ["Pending", "Approved", "Rejected"],
      form: {
        employee_id: null,
        department_id: null,
        month: "",
        status: "",
      },
      employee_list: [],
      department: [],
      role: null,
      isAdmin: false,
      isEmployee: false,
      updateId: null,
      status: null,
      hasCreatePermission: null,
      hasReadPermission: null,
      hasEditPermission: null,
      hasDeletePermission: null,
      hasImportPermission: null,
    };
  },
  methods: {
    capitalizeFirst(str) {
      if (!str) return "—";
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    uploadFile(id) {
      this.updateId = id;
    },
    updateStatus(id, status) {
      this.updateId = id;
      this.status = status;
    },
    deletePayslip(id) {
      this.updateId = id;
    },
    updatePayslipStatus(payslipId, status) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var postform = new FormData();
      postform.append("status", status);

      axios
        .put(`/payslip/updatestatus/${payslipId}`, postform)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response?.data?.message || "Successfully Uplaoded",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          if (status === "approved") {
            this.$nextTick(() => {
              const modalEl = document.getElementById("upload_payslip");
              this.uploadModal = new bootstrap.Modal(modalEl);
              this.uploadModal.show();
            });
            // }
            // if (status === "approved") {
            //   this.$nextTick(() => {
            //     const modalEl = document.getElementById("upload_payslip");
            //     modalEl.classList.add("show");
            //     modalEl.style.display = "block";
            //     modalEl.removeAttribute("aria-hidden");
            //     modalEl.setAttribute("aria-modal", "true");
            //   });
          } else {
            var params = {
              params: {
                per_page: this.pagination.pageSize,
                page: this.pagination.current,
              },
            };
            this.loadCommonData(params);
          }
        })
        .catch((error) => {
          loader.hide();
          notification.open({
            message: error.response?.data?.message || "Server Error",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: { background: process.env.VUE_APP_WARNING_COLOR },
          });
        });
    },
    reloadPayData() {
      let params = {
        params: {
          per_page: this.pagination.pageSize,
          page: this.pagination.current,
          employee_id: this.form.employee_id,
          department_id: this.form.department_id,
          month: this.form.month,
          status: this.form.status,
        },
      };
      this.loadCommonData(params);
    },
    filterPayslip() {
      let params = {
        params: {
          per_page: this.pagination.pageSize,
          employee_id: this.form.employee_id,
          department_id: this.form.department_id,
          month: this.form.month,
          status: this.form.status,
        },
      };
      this.loadCommonData(params);
    },
    clearFilter() {
      this.form = {
        employee_id: null,
        department_id: null,
        month: "",
        status: "",
      };
      this.reloadPayData();
    },
    updatePerPage() {
      var params = {
        params: {
          per_page: this.pagination.pageSize,
          employee_id: this.form.employee_id,
          department_id: this.form.department_id,
          month: this.form.month,
          status: this.form.status,
        },
      };
      this.loadCommonData(params);
    },
    handleTableChange(pagesize) {
      var params = {
        params: {
          per_page: pagesize.pageSize,
          page: pagesize.current,
          employee_id: this.form.employee_id,
          department_id: this.form.department_id,
          month: this.form.month,
          status: this.form.status,
        },
      };

      this.loadCommonData(params);
    },
    loadCommonData(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/payslip", params)
        .then((response) => {
          if (response?.data?.data) {
            this.pagination.total = response.data.data.total || 0;
            this.pagination.current = response.data.data.current_page || 1;
            this.pagination.pageSize = response.data.data.per_page || 10;

            this.data = response.data.data.data || [];
          } else {
            this.pagination.total = 0;
            this.pagination.current = 1;
            this.pagination.pageSize = 10;
            this.data = [];
          }

          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          var response = error.response;
          if (
            error.response?.status == 401 &&
            response?.data?.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response?.data?.message || "An error occurred",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    downloadPayslip(payslipId) {
      var token = window.localStorage.getItem("token");

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get(`/payslip/download/${payslipId}`, {
          responseType: "blob",
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = url;

          const contentDisposition = response.headers["content-disposition"];
          let fileName = "payslip.pdf";
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) fileName = match[1];
          }

          link.download = fileName;
          link.click();
          URL.revokeObjectURL(link.href);
          loader.hide();
        })
        .catch(async (error) => {
          loader.hide();
          const response = error.response;

          let errorMsg = "Something went wrong";

          try {
            const text = await response.data.text();
            const json = JSON.parse(text);
            errorMsg = json.message || errorMsg;
          } catch (e) {
            errorMsg = response.statusText || errorMsg;
          }

          if (response.status == 401 && errorMsg == "Unauthenticated.") {
            localStorage.clear();
            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: { background: process.env.VUE_APP_WARNING_COLOR },
            });
            this.$router.push({ name: "login" }).catch(() => {});
          } else {
            this.errorMessage = errorMsg;
            notification.open({
              message: this.errorMessage,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: { background: process.env.VUE_APP_WARNING_COLOR },
            });
          }
        });
    },
    loadAllEmployee() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/employees/all")
        .then((response) => {
          this.employee_list = [];

          if (response?.data?.data && Array.isArray(response.data.data)) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.employee_list.push({
                id: response.data.data[i].id,
                text:
                  (response.data.data[i].first_name || "") +
                  " " +
                  (response.data.data[i].last_name || ""),
              });
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
          var response = error.response;

          if (
            error.response?.status == 401 &&
            response?.data?.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch(() => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response?.data?.message || "An error occurred",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadAllDepartments() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/departments/all")
        .then((response) => {
          this.department = [];
          if (response?.data?.data && response?.data?.data?.length) {
            this.department = [{ id: "", text: "Select" }];

            for (let i = 0; i < response?.data?.data.length; i++) {
              this.department.push({
                id: response.data.data[i].id,
                text: response.data.data[i].name,
              });
            }
          } else {
            this.department = [{ id: "", name: "No Records" }];
          }
        })
        .catch((error) => {
          console.log("error", error);
          var response = error.response;

          if (
            error.response?.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch(() => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response?.data?.message || "An error occurred",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
  },
  mounted() {
    this.$store
      .dispatch("userPermissions", { module: "payslip", action: "read" })
      .then((response) => {
        this.hasReadPermission = null;
        this.$nextTick(() => {
          this.hasReadPermission = response === "true";

          if (!this.hasReadPermission) {
            notification.open({
              message: "You don't have access to this page!",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            var user_role = window.localStorage.getItem("role");

            if (user_role && user_role.includes("Employee")) {
              this.$router
                .push({ name: "employee-dashboard" })
                .catch((error) => {});
            } else {
              this.$router
                .push({ name: "admin-dashboard" })
                .catch((error) => {});
            }
          }
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "payslip", action: "create" })
      .then((response) => {
        this.hasCreatePermission = null;
        this.$nextTick(() => {
          this.hasCreatePermission = response === "true";
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "payslip", action: "write" })
      .then((response) => {
        this.hasEditPermission = null;
        this.$nextTick(() => {
          this.hasEditPermission = response === "true";
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "payslip", action: "delete" })
      .then((response) => {
        this.hasDeletePermission = null;
        this.$nextTick(() => {
          this.hasDeletePermission = response === "true";
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "payslip", action: "import" })
      .then((response) => {
        this.hasImportPermission = null;
        this.$nextTick(() => {
          this.hasImportPermission = response === "true";
        });
      });

    this.role = localStorage.getItem("role");

    if (this.role && this.role.includes("Employee")) {
      this.isEmployee = true;
      this.columns = employeeColumns;
    } else {
      this.isAdmin = true;
      this.columns = adminColumns;
    }

    var params = {
      params: { per_page: this.pagination.pageSize },
    };
    this.loadCommonData(params);
    this.loadAllEmployee();
    this.loadAllDepartments();
  },
};
</script>
